import { useTranslation } from 'react-i18next';
import { useShowToaster } from '@shared/ui/messages/useToaster';

export function useRequestError() {
  const showToaster = useShowToaster();
  const { t } = useTranslation();

  return (err, { rethrowValidation = true } = {}) => {
    if (rethrowValidation && err?.response?.status === 422) {
      throw err;
    }

    showToaster('error', err?.response?.data?.message || t('request_error'));
    return false;
  };
}
